<div class="prompt-popover" [class.prompt-popover--embedded]="embedded" *ngIf="showPromptPopover" (click)="onStopPropagation($event)">
    <div class="prompt-header">
        <span class="prompt-title">Playbooks</span>
        <small class="text-muted">Use ↑↓ to navigate, Enter to select</small>
    </div>
    <div class="prompt-list">
        <div class="prompt-item" 
             *ngFor="let playbook of availablePlaybooks; let i = index"
             [class.selected]="i === currentSelectedIndex"
             (click)="selectPlaybook(playbook)">
            <i class="fa-regular {{ playbook.icon }} prompt-item-icon"></i>
            <div class="prompt-name">{{ playbook.title }}</div>
        </div>
        <div class="no-prompts" *ngIf="availablePlaybooks.length === 0">
            <small class="text-muted">No playbooks available for this agent</small>
        </div>
    </div>
</div>
